import axiosNew from '../../helpers/axios'

export const fetchGlobalSearchResults = async (payload = {}) => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: 'support/global-search',
                method: 'POST',
                data: payload,
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const fetchRecentItemsService = async () => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: 'support/recent-items',
                method: 'GET',
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

